import { SCREENS } from "../constants/screens"

export const routeScreenMapping = {
  "/plan-new-date": SCREENS.PLAN_NEW_DATE,
  "/choose-restaurant": SCREENS.SELECT_RESTAURANT,
  "/confirm-date": SCREENS.SELECT_MENU_ITEMS,
  "/contact": SCREENS.CONTACT,
  "/get-help": SCREENS.HELP,
  "/my-partner": SCREENS.MY_PARTNER,
  "/integrations": SCREENS.INTEGRATIONS,
  "/checkout": SCREENS.CHECKOUT,
  "/date/wait": SCREENS.ADDRESS_WAIT_SCREEN,
  "/checkout/wait": SCREENS.CHECKOUT,
  "/checkout/detail": SCREENS.CHECKOUT,
  "/checkout/payment": SCREENS.CHECKOUT,
  "/get-address": SCREENS.GET_ADDRESS,
  "/meet-concierge": SCREENS.MEET_CONCIERGE,
  "/bond-over-memories": SCREENS.BOND_OVER_MEMORIES,
}

export const FIREBASE_STATE_KEYS = {
  ACTIVE_SCREEN: "activeScreen",
  PRESENCE: "presence",
  CART_LIST: "cartList",
  DELIVERY_MINIMUM: "deliveryMinimum",
  ACTIVE_ROUTE: "activeRoute",
  IS_ORDER_COMBINED: "isOrderCombined",
  NOTIFY_ORDER_COMBINE: "notifyCombineOrder",
  IS_ONLINE: "isOnline",
  GET_READY: "getReady",
  NOTIFY_INVITE: "notifyInvite",
  LAST_CHANGED: "lastChanged",
  RESTAURANTS: "restaurants",
  USER_DETAILS: "userDetails",
  PROFILE_IMAGE: "profile_image",
  SUGGESTIONS: "suggestions",
  IN_CART: "inCart",
  SUGGESTED_RESTAURANT: "suggestedRestaurant",
  UNREAD_NOTIFICATION: "unreadNotification",
  PLAN_A_DATE: "planADate",
  STATUS: "status",
  REJECTED_BY: "rejectedBy",
  ROUTE: "route",
  RESTAURANT_ID: "restaurantId",
  RESTAURANT_NAME: "restaurantName",
  SUGGESTION_STATE: "suggestionState",
  ACCEPTED_RESTAURANT: "acceptedRestaurant",
  PAY_STATUS: "payStatus",
  MENU_ITEM_SUGGESTIONS: "menuItemSuggestions",
  SUGGESTED_TO_PARTNER: "suggestedToPartner",
  ITEM: "item",
  DELIVERY_COM_CART: "deliveryComCart",
  CHAT_SPACE_NAME: "chatSpaceName",
  GEO_LOCATION: "geoLocation",
  ADDRESS: "address",
  USER_ADDRESS: "user_address",
  READY_FOR_CHECKOUT: "readyForCheckout",
  RESET_RESTAURANT: "resetRestaurant",
  RESET_BY: "resetBy",
  DELIVERY_ORDER_ID: "deliveryOrderId",
  DISPLAY_NAME: "display_name",
  RESET_ORDER: "resetOrder",
  FIRST_USER_READY_FOR_CHECKOUT: "firstUserReadyForCheckout",
  CART_NOTIFICATION: "cartNotification",
  INDICATOR: "indicator",
  NOTIFY_ADDRESS_CHANGE: "notifyAddressChange",
  MESSAGE: "message",
  TIMESTAMP: "timestamp",
  DRAFT_ADDRESS: "draftAddress",
  BACK_TO_PLANNING: "backToPlanning",
  RESTAURANT_ADDRESS: "restaurantAddress",
  SHOULD_OPEN_CART: "shouldOpenCart",
  SHARED_PROFILE_ANSWERS: "sharedProfileAnswers",
  JOURNAL_DATE: "journal_date",
  MEMBERS: "members",
  LAST_SEEN_MESSAGES_AT: "lastSeenMessagesAt",
}
